<template>
  <div v-title="$route.meta.title"
       class="asr-check-result-table">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>录音风险管理</el-breadcrumb-item>
        <el-breadcrumb-item>录音风险列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="asr-check-result-table__card asr-check-result-table__card--search">
      <div class="asr-check-result-table__card-header"
           @click="searchExpanded = !searchExpanded">
        <span>搜索</span>
        <i :class="searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
      </div>

      <el-form v-show="searchExpanded"
               :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="left"
               size="small"
               class="asr-check-result-table__search-form"
               @submit.native.prevent="onSearch()">
        <div class="asr-check-result-table__search-grid">
          <el-form-item label="工单ID"
                        prop="orderid">
            <el-input v-model="search.orderid"
                      placeholder="请输入工单ID"
                      clearable />
          </el-form-item>
          <el-form-item label="项目"
                        prop="projectid">
            <remote-select class="width-max"
                           clearable
                           id-key="number"
                           label-key="name"
                           value-key="id"
                           placeholder="请选择项目"
                           v-model="search.projectid"
                           :query-request="getProjectTableQuery"
                           :find-request="getProjectDetail"
                           @change="onProjectChange" />
          </el-form-item>
          <el-form-item label="批次"
                        prop="batchid">
            <remote-select class="width-max"
                           clearable
                           :disabled="!search.projectid"
                           id-key="number"
                           label-key="detail"
                           value-key="id"
                           placeholder="请选择批次"
                           v-model="search.batchid"
                           :query-request="(_) => getBatchTable(Object.assign({ projectid: search.projectid }, _))"
                           :find-request="getBatchDetail" />
          </el-form-item>
          <el-form-item label="风险配置"
                        prop="audio_asr_check_template_id">
            <remote-select class="width-max"
                           clearable
                           keyword-key="title"
                           label-key="title"
                           value-key="id"
                           placeholder="请选择录音风险配置"
                           v-model="search.audio_asr_check_template_id"
                           :query-request="queryAudioAsrCheckTemplateSelect"
                           :find-request="getAudioAsrCheckTemplate" />
          </el-form-item>
          <el-form-item label="零工ID"
                        prop="userid">
            <el-input v-model="search.userid"
                      placeholder="请输入零工ID"
                      clearable />
          </el-form-item>
          <el-form-item label="AI处理结果"
                        prop="ai_process_result">
            <el-select v-model="search.ai_process_result"
                       placeholder="请选择"
                       clearable
                       class="width-max">
              <el-option label="成功"
                         value="success" />
              <el-option label="处理中"
                         value="processing" />
              <el-option label="失败"
                         value="failed" />
            </el-select>
          </el-form-item>
          <el-form-item label="触发风险"
                        prop="trigger_risk_status">
            <el-select v-model="search.trigger_risk_status"
                       placeholder="请选择"
                       clearable
                       class="width-max">
              <el-option label="触发"
                         :value="1" />
              <el-option label="未触发"
                         :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="处理时间"
                        prop="processed_at">
            <el-date-picker v-model="search.processed_at"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :picker-options="dateTimePickerRangeOptions"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="width-max"
                            :default-time="['00:00:00', '23:59:59']"
                            clearable />
          </el-form-item>
        </div>
        <div class="asr-check-result-table__search-actions">
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索</el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetSearch()">重置</el-button>
        </div>
      </el-form>
    </div>

    <div class="asr-check-result-table__stats">
      <div class="asr-check-result-table__stats-grid">
        <div class="asr-check-result-stat-card is-static">
          <div class="asr-check-result-stat-card__content">
            <div class="asr-check-result-stat-card__label">总数</div>
            <div class="asr-check-result-stat-card__value">{{ stats.total_count | seperateThousands }}</div>
          </div>
          <div class="asr-check-result-stat-card__icon asr-check-result-stat-card__icon--total">
            <i class="el-icon-tickets" />
          </div>
        </div>
        <div :class="['asr-check-result-stat-card', 'is-clickable', { 'is-active': activeStatKey === 'no_risk' }]"
             @click="onStatCardClick('no_risk')">
          <div class="asr-check-result-stat-card__content">
            <div class="asr-check-result-stat-card__label">无风险</div>
            <div class="asr-check-result-stat-card__value asr-check-result-stat-card__value--ok">{{ stats.no_risk_count | seperateThousands }}</div>
          </div>
          <div class="asr-check-result-stat-card__icon asr-check-result-stat-card__icon--ok">
            <i class="el-icon-circle-check" />
          </div>
        </div>
        <div :class="['asr-check-result-stat-card', 'is-clickable', { 'is-active': activeStatKey === 'processing' }]"
             @click="onStatCardClick('processing')">
          <div class="asr-check-result-stat-card__content">
            <div class="asr-check-result-stat-card__label">处理中</div>
            <div class="asr-check-result-stat-card__value">{{ stats.processing_count | seperateThousands }}</div>
          </div>
          <div class="asr-check-result-stat-card__icon asr-check-result-stat-card__icon--processing">
            <i class="el-icon-time" />
          </div>
        </div>
        <div :class="['asr-check-result-stat-card', 'is-clickable', { 'is-active': activeStatKey === 'risk' }]"
             @click="onStatCardClick('risk')">
          <div class="asr-check-result-stat-card__content">
            <div class="asr-check-result-stat-card__label">风险</div>
            <div class="asr-check-result-stat-card__value asr-check-result-stat-card__value--risk">{{ stats.risk_count | seperateThousands }}</div>
          </div>
          <div class="asr-check-result-stat-card__icon asr-check-result-stat-card__icon--risk">
            <i class="el-icon-warning" />
          </div>
        </div>
        <div :class="['asr-check-result-stat-card', 'is-clickable', { 'is-active': activeStatKey === 'failed' }]"
             @click="onStatCardClick('failed')">
          <div class="asr-check-result-stat-card__content">
            <div class="asr-check-result-stat-card__label">处理失败</div>
            <div class="asr-check-result-stat-card__value">{{ stats.failed_count | seperateThousands }}</div>
          </div>
          <div class="asr-check-result-stat-card__icon asr-check-result-stat-card__icon--failed">
            <i class="el-icon-warning-outline" />
          </div>
        </div>
      </div>
    </div>

    <div class="asr-check-result-table__card">
      <div class="asr-check-result-table__card-header"
           @click="listExpanded = !listExpanded">
        <span>列表</span>
        <div class="asr-check-result-table__card-header-actions">
          <el-button type="text"
                     icon="el-icon-refresh"
                     class="asr-check-result-table__header-action"
                     @click.stop="onRefresh()" />
          <span class="asr-check-result-table__header-action">
            <i :class="listExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
          </span>
        </div>
      </div>

      <div v-show="listExpanded"
           class="asr-check-result-table__list-body">
        <div class="asr-check-result-table__toolbar">
          <el-button type="success"
                     size="small"
                     icon="sj-icon-export"
                     @click="onExportSearch">按搜索结果导出</el-button>
        </div>
        <div class="asr-check-result-table__table-wrap">
          <el-table :data="table"
                    class="asr-check-result-table__table"
                    style="width: 100%">
            <el-table-column prop="orderid"
                             label="工单ID"
                             width="100">
              <template slot-scope="scope">
                <router-link :to="`/order/review/${scope.row.orderid}`"
                             target="_blank">
                  <el-link type="primary">{{ scope.row.orderid }}</el-link>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column prop="task_title"
                             label="任务标题"
                             min-width="180"
                             show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.task_title || '-' }}</template>
            </el-table-column>
            <el-table-column prop="project_name"
                             label="项目名称"
                             min-width="160"
                             show-overflow-tooltip>
              <template slot-scope="scope">{{ formatNameWithId(scope.row.project_name, scope.row.projectid) }}</template>
            </el-table-column>
            <el-table-column prop="province_name"
                             label="省"
                             min-width="90"
                             show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.province_name || '-' }}</template>
            </el-table-column>
            <el-table-column prop="city_name"
                             label="市"
                             min-width="90"
                             show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.city_name || '-' }}</template>
            </el-table-column>
            <el-table-column prop="area_name"
                             label="区"
                             min-width="90"
                             show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.area_name || '-' }}</template>
            </el-table-column>
            <el-table-column prop="worker_display"
                             label="零工姓名"
                             min-width="140"
                             show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.worker_display || '-' }}</template>
            </el-table-column>
            <el-table-column prop="trigger_risk_status_text"
                             label="触发风险"
                             width="100"
                             align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.trigger_risk_status_text"
                      :class="['asr-check-result-table__trigger-status', `is-${Number(scope.row.trigger_risk_status)}`]">
                  {{ scope.row.trigger_risk_status_text }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="violation_types"
                             label="违规类型"
                             min-width="220">
              <template slot-scope="scope">
                <div v-if="scope.row.violation_types && scope.row.violation_types.length"
                     class="asr-check-result-table__badges">
                  <el-tag v-for="(alias, idx) in scope.row.violation_types"
                          :key="`${scope.row.id}-${idx}-${alias}`"
                          size="mini"
                          type="danger"
                          class="asr-check-result-table__badge">
                    {{ alias }}
                  </el-tag>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="ai_process_result_text"
                             label="AI处理结果"
                             min-width="160"
                             show-overflow-tooltip
                             align="center">
              <template slot-scope="scope">
                <span :class="['asr-check-result-table__ai-status', `is-${scope.row.ai_process_result}`]">
                  {{ scope.row.ai_process_result_text || '-' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="processed_at"
                             label="处理时间"
                             width="170">
              <template slot-scope="scope">{{ scope.row.processed_at || '-' }}</template>
            </el-table-column>
            <el-table-column prop="audio_asr_check_template_title"
                             label="录音风险配置"
                             min-width="220"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                <router-link v-if="Number(scope.row.audio_asr_check_template_id) > 0"
                             :to="`/audio-asr-check/template/update/${scope.row.audio_asr_check_template_id}`"
                             class="asr-check-result-table__tpl-link"
                             target="_blank">
                  <el-link type="primary">{{ formatNameWithId(scope.row.audio_asr_check_template_title, scope.row.audio_asr_check_template_id) }}</el-link>
                </router-link>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right"
                             label="操作"
                             width="220"
                             align="left">
              <template slot-scope="scope">
                <div class="asr-check-result-table__actions">
                  <a href="javascript:;"
                     class="asr-check-result-table__action is-view"
                     @click.prevent="onViewRecord(scope.row)">
                    查看
                  </a>
                  <a v-if="Number(scope.row.can_recheck) === 1"
                     href="javascript:;"
                     class="asr-check-result-table__action is-recheck"
                     @click.prevent="onRecheckRisk(scope.row)">
                    重新检测风险
                  </a>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination">
          <el-pagination background
                         @size-change="handleSizePageChange"
                         @current-change="handleCurrentPageChange"
                         :current-page="pagination.current_page"
                         :page-sizes="[20, 50, 100, 200]"
                         :page-size="pagination.per_page"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="pagination.total" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import table, { removeEmptyParams } from '@core/mixins/table'
import dateTimePicker from '@core/mixins/dateTimePicker'
import OrderRecordAudioViewer from '@/views/question-review/components/OrderRecordAudioViewer'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchExpanded: true,
      listExpanded: true,
      activeStatKey: null,
      search: {
        orderid: null,
        projectid: null,
        batchid: null,
        audio_asr_check_template_id: null,
        userid: null,
        ai_process_result: null,
        trigger_risk_status: null,
        processed_at: [],
      },
      table: [],
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0,
      },
      stats: {
        total_count: 0,
        no_risk_count: 0,
        processing_count: 0,
        risk_count: 0,
        failed_count: 0,
      },
      // 项目/批次单选用 String（详情 id 多为字符串）；配置详情 id 为数字，用 Number 才能回显名称
      searchFieldType: {
        orderid: Number,
        projectid: String,
        batchid: String,
        audio_asr_check_template_id: Number,
        userid: Number,
        trigger_risk_status: Number,
        processed_at: Array,
      },
    }
  },
  methods: {
    ...request.map([
      'getProjectTable',
      'getProjectDetail',
      'getBatchTable',
      'getBatchDetail',
      'queryAudioAsrCheckTemplateSelect',
      'getAudioAsrCheckTemplate',
    ]),
    getProjectTableQuery (params) {
      return this.getProjectTable(Object.assign({
        current_page: 1,
        per_page: 20,
      }, params || {}))
    },
    getTableData (params) {
      this.loadStats(params)
      this.syncActiveStatKey(params)
      return this.fetchTableData(params)
    },
    fetchTableData (params) {
      return request.page('queryAudioAsrCheckOrderResult', params)
    },
    loadStats (params) {
      const query = removeEmptyParams(Object.assign({}, this.lastSeachParams || {}, params || {}))
      delete query.current_page
      delete query.per_page
      delete query.ai_process_result
      delete query.trigger_risk_status
      return request.page('queryAudioAsrCheckOrderResultSummary', query).then(({ data }) => {
        this.stats.total_count = Number(data.total_count) || 0
        this.stats.no_risk_count = Number(data.no_risk_count) || 0
        this.stats.processing_count = Number(data.processing_count) || 0
        this.stats.risk_count = Number(data.risk_count) || 0
        this.stats.failed_count = Number(data.failed_count) || 0
      }).catch(() => {})
    },
    syncActiveStatKey (params) {
      const source = Object.assign({}, this.search, params || {})
      if (Number(source.trigger_risk_status) === 2) {
        this.activeStatKey = 'no_risk'
        return
      }
      if (Number(source.trigger_risk_status) === 1) {
        this.activeStatKey = 'risk'
        return
      }
      if (source.ai_process_result === 'processing') {
        this.activeStatKey = 'processing'
        return
      }
      if (source.ai_process_result === 'failed') {
        this.activeStatKey = 'failed'
        return
      }
      this.activeStatKey = null
    },
    onStatCardClick (key) {
      // 总数不可点；其余卡片带上对应筛选项并搜索
      if (key === 'total') {
        return
      }
      this.search.ai_process_result = null
      this.search.trigger_risk_status = null
      if (key === 'no_risk') {
        this.search.trigger_risk_status = 2
      } else if (key === 'risk') {
        this.search.trigger_risk_status = 1
      } else if (key === 'processing') {
        this.search.ai_process_result = 'processing'
      } else if (key === 'failed') {
        this.search.ai_process_result = 'failed'
      }
      this.activeStatKey = key
      this.onSearch()
    },
    onExportSearch () {
      // 与当前列表一致：用上次搜索参数，避免改筛选未点搜索就导出错数据
      const exportParams = removeEmptyParams(_.cloneDeep(this.lastSeachParams || {}))
      delete exportParams.current_page
      delete exportParams.per_page
      delete exportParams['']

      const templateId = exportParams.audio_asr_check_template_id
      if (!templateId) {
        this.$message.warning('请先搜索（并选择录音风险配置）后再导出')
        return
      }
      request.common('getAudioAsrCheckTemplate', { id: templateId }).then(({ data }) => {
        const questions = (data && data.questions) || []
        const riskAliases = []
        const seen = {}
        const pushAlias = (raw) => {
          const alias = raw != null ? String(raw).trim() : ''
          if (!alias || seen[alias]) {
            return
          }
          seen[alias] = true
          riskAliases.push(alias)
        }
        questions.forEach((item) => {
          pushAlias(item && item.alias)
        })
        // 合并当前列表历史 risk_trigger_map 键，避免配置改名后历史别名整列变成「否」
        ;(this.table || []).forEach((row) => {
          const map = (row && row.risk_trigger_map) || {}
          Object.keys(map).forEach(pushAlias)
        })
        if (!riskAliases.length) {
          this.$message.warning('该录音风险配置下没有风险名称，无法展开导出列')
          return
        }

        const riskColumns = riskAliases.map((alias, index) => ({
          key: `risk_flag_${index}`,
          text: alias,
          formatter: (row) => {
            const map = (row && row.risk_trigger_map) || {}
            if (!Object.prototype.hasOwnProperty.call(map, alias)) {
              return '-'
            }
            return Number(map[alias]) === 1 ? '是' : '否'
          },
        }))

        this.$export(`${this.$route.meta.title}_搜索结果`, {
          fileHeader: [
            { key: 'orderid', text: '工单ID' },
            { key: 'task_title', text: '任务标题' },
            {
              key: 'project_name',
              text: '项目名称',
              formatter: (row) => this.formatNameWithId(row.project_name, row.projectid),
            },
            { key: 'province_name', text: '省' },
            { key: 'city_name', text: '市' },
            { key: 'area_name', text: '区' },
            { key: 'worker_display', text: '零工姓名' },
            { key: 'trigger_risk_status_text', text: '触发风险' },
            ...riskColumns,
            { key: 'ai_process_result_text', text: 'AI处理结果' },
            { key: 'processed_at', text: '处理时间' },
            {
              key: 'audio_asr_check_template_title',
              text: '录音风险配置',
              formatter: (row) => this.formatNameWithId(row.audio_asr_check_template_title, row.audio_asr_check_template_id),
            },
          ],
          total: this.pagination.total,
          request: this.fetchTableData,
          requestParams: exportParams,
        })
      })
    },
    onViewRecord (row) {
      if (!row || !row.orderid) {
        this.$message.warning('缺少工单ID')
        return
      }
      OrderRecordAudioViewer.open({ orderid: row.orderid })
    },
    onRecheckRisk (row) {
      if (!row || !row.orderid) {
        this.$message.warning('缺少工单ID')
        return
      }
      const isAsrFailed = Number(row.status) === 3
      const tip = isAsrFailed
        ? `确认对工单 ${row.orderid} 重新检测风险？将重新发起 ASR，再由定时任务继续 LLM 分析。`
        : `确认对工单 ${row.orderid} 重新检测风险？将重置为等待 LLM，由定时任务重新分析。`
      this.$confirm(tip, '重新检测风险', { type: 'warning' }).then(() => {
        return request.common('recheckAudioAsrCheckOrderResult', { orderid: row.orderid }).then(() => {
          this.$message.success('已提交重新检测，等待定时任务处理')
          this.onRefresh()
        })
      }).catch(() => {})
    },
    formatNameWithId (name, id) {
      const label = name == null || name === '' ? '' : String(name)
      const numId = id == null || id === '' || Number(id) === 0 ? '' : String(id)
      if (label && numId) {
        return `${label} / ${numId}`
      }
      return label || numId || '-'
    },
    resetSearch () {
      this.$refs[this.refSearchForm].resetFields()
      this.activeStatKey = null
      this.onSearch()
    },
    onProjectChange () {
      this.search.batchid = null
    },
  },
}
</script>

<style lang="scss" scoped>
.asr-check-result-table {
  &__stats {
    margin-top: 16px;
  }

  &__stats-grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 16px;
  }

  &__card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    overflow: hidden;

    & + & {
      margin-top: 16px;
    }
  }

  &__stats + &__card {
    margin-top: 16px;
  }

  &__card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 24px;
    border-bottom: 1px solid #ebeef5;
    cursor: pointer;
    user-select: none;
    color: #606266;
    font-size: 14px;
    font-weight: 500;

    i {
      color: #909399;
    }
  }

  &__card-header-actions {
    display: flex;
    align-items: center;
    gap: 8px;

    ::v-deep .asr-check-result-table__header-action.el-button {
      min-width: 24px;
      padding: 0;
      margin: 0;
    }
  }

  &__header-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    margin: 0;
    color: #909399;
    flex-shrink: 0;
    line-height: 1;

    i {
      font-size: 14px;
    }
  }

  &__search-form {
    padding: 16px 24px 20px;
  }

  &__search-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px 16px;
  }

  &__search-actions {
    margin-top: 16px;
    padding-top: 4px;
  }

  &__list-body {
    padding: 16px;
  }

  &__toolbar {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    padding: 0 0 16px;
  }

  &__table-wrap {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 0;

    // 外层已有边框，去掉 el-table 自带底/侧边线避免重叠
    ::v-deep .el-table::before,
    ::v-deep .el-table::after {
      display: none;
    }

    ::v-deep .el-table__body tr:last-child td {
      border-bottom: none;
    }
  }

  &__table {
    ::v-deep {
      th {
        background: #f5f7fa;
        color: #909399;
        font-size: 12px;
        font-weight: 500;
      }

      td {
        font-size: 14px;
        color: #303133;
      }

      .el-table__row:hover > td {
        background: #fafafa;
      }
    }
  }

  &__ai-status {
    font-weight: 500;

    &.is-success {
      color: #16a34a;
    }

    &.is-processing {
      color: #ca8a04;
    }

    &.is-failed {
      color: #dc2626;
    }
  }

  &__trigger-status {
    font-weight: 500;

    &.is-0 {
      color: #909399;
    }

    &.is-1 {
      color: #dc2626;
    }

    &.is-2 {
      color: #16a34a;
    }
  }

  &__badges {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 2px 0;
  }

  &__badge {
    margin: 0;
  }

  &__tpl-link {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;

    ::v-deep .el-link {
      display: inline;
      font-size: inherit;
    }
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 4px 0;
  }

  &__action {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    line-height: 18px;
    font-weight: 500;
    background: #fff;
    cursor: pointer;
    transition: background-color 0.15s ease;
    outline: none;
    font-family: inherit;
    text-decoration: none;

    &.is-view {
      color: #606266;
      border: 1px solid #909399;
    }

    &.is-recheck {
      color: #2563eb;
      border: 1px solid #3b82f6;
    }

    &:hover {
      background: #f9fafb;
    }
  }

  .pagination {
    margin: 16px auto 0;
    text-align: center;
  }
}

.asr-check-result-stat-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  padding: 20px 24px;
  min-height: 96px;
  box-sizing: border-box;
  border: 1px solid transparent;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &.is-clickable {
    cursor: pointer;

    &:hover {
      border-color: #c6e2ff;
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.12);
    }
  }

  &.is-active {
    border-color: #409eff;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.18);
  }

  &.is-static {
    cursor: default;
  }
}

.asr-check-result-stat-card__label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
  line-height: 1.2;
}

.asr-check-result-stat-card__value {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
  line-height: 1.2;
}

.asr-check-result-stat-card__value--risk {
  color: #f56c6c;
}

.asr-check-result-stat-card__value--ok {
  color: #16a34a;
}

.asr-check-result-stat-card__icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i {
    font-size: 24px;
  }
}

.asr-check-result-stat-card__icon--total {
  background: #f4f4f5;
  color: #606266;
}

.asr-check-result-stat-card__icon--ok {
  background: #f0fdf4;
  color: #16a34a;
}

.asr-check-result-stat-card__icon--processing {
  background: #ecf5ff;
  color: #409eff;
}

.asr-check-result-stat-card__icon--risk {
  background: #fef0f0;
  color: #f56c6c;
}

.asr-check-result-stat-card__icon--failed {
  background: #f4f4f5;
  color: #909399;
}

@media (max-width: 1200px) {
  .asr-check-result-table {
    &__search-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    &__stats-grid {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
}

@media (max-width: 768px) {
  .asr-check-result-table {
    &__search-grid {
      grid-template-columns: 1fr;
    }

    &__stats-grid {
      grid-template-columns: 1fr;
    }
  }
}
</style>

<style lang="scss">
.asr-check-result-table__search-form {
  .el-form-item {
    margin-bottom: 0;
  }

  .el-form-item__label {
    color: #606266;
    font-size: 13px;
    line-height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/audio-asr-check/pages/AudioAsrCheckResultTable.vue